<template>
  <div v-if="message.role != 'bot'">
    <div v-if="index == indexFirstUnreadMessage" class="new-messages-separator">
      <span>
        {{ unreadMessagesCount }}
        <template v-if="unreadMessagesCount == 1">
          {{ translate("chat", "новое сообщение", {}) }}
        </template>
        <template v-else>
          {{ translate("chat", "новых сообщений", {}) }}
        </template>
      </span>
    </div>
    <div
      :class="
        message.is_deleted
          ? 'message-wrap message-wrap--delete'
          : 'message-wrap'
      "
    >
      <div class="user-avatar">
        <img
          v-if="message.role == 'admin'"
          src="/img/chat-admin-avatar.png"
          class="admin-avatar"
          alt=""
        />
        <img v-else :src="message.photo" alt="" />
        <div
          v-if="users[message.user_id] && users[message.user_id].online"
          class="user-status online"
        ></div>
      </div>
      <div class="message-info">
        <div class="user-name">{{ message.username }}</div>
        <span class="user-role">
          <template v-if="message.role == 'admin'">
            <span class="user-role--admin">{{
              translate("chat", "Админ", {})
            }}</span>
          </template>
          <template v-if="message.role == 'user'">
            <span class="user-role--user">{{
              translate("chat", "Клиент", {})
            }}</span>
          </template>
          <template v-if="message.role == 'booster'">
            <span class="user-role--booster">{{
              translate("chat", "Бустер", {})
            }}</span>
          </template>
        </span>
        <div v-if="accessLevel == 'admin'" class="delete-message">
          <span @click="deleteItem(message.id)">{{
            translate("chat", "Удалить сообщение", {})
          }}</span>
        </div>
        <div class="message-time" :title="message.dateFull">
          {{ message.created_at }}
        </div>
      </div>
      <div class="message-content">
        <template v-if="message.is_deleted == 0">
          {{ message.message }}
        </template>
        <template v-else>
          <div v-if="accessLevel == 'admin'" class="message-content-delete">
            {{ message.message }}
          </div>
          <div v-else class="message-content-delete">
            {{ translate("chat", "Сообщение удалено", {}) }}
          </div>
        </template>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="bot-message-wrap">
      <img :src="message.photo" class="bot-avatar" alt="anylvl chat bot" />
      <div class="message-info">
        <div class="bot-message-header">
          {{ translate("chat", "Придержи коней, ковбой!", {}) }}
        </div>
      </div>
      <div class="message-content">
        {{ message.message }}
      </div>
    </div>
    <div class="bot-message-subheader">
      {{ translate("chat", "Это сообщение видите только Вы", {}) }}
    </div>
  </div>
</template>
<script>
;
export default {
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    users: {
      type: Object,
      default: () => ({}),
    },
    indexFirstUnreadMessage: {
      type: Number,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    unreadMessagesCount: {
      type: Number,
      default: null,
    },
    accessLevel: {
      type: String,
      default: null,
    },
    deleteMessage: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    deleteItem: function (id) {
      console.log("delete");
      this.deleteMessage(id);
    },
    translate(source, message, params) {
      return translate(source, message, params);
    },
  },
};
</script>
<style lang="scss" scoped>
.message-wrap {
  position: relative;
  min-height: 60px;
  padding-left: 76px;
  padding-right: 24px;
  padding-bottom: 18px;
}
.bot-message-wrap {
  position: relative;
  min-height: 130px;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 3px;

  padding-top: 20px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 14px;

  background: #fbfcfe;
  border: 1px solid #dfdede;

  border-radius: 8px;
  .message-info {
    font-size: 16px;
    line-height: 130%;
    color: #717070;
    font-weight: 600;
    margin-bottom: 3px;
  }
}
.bot-message-subheader {
  padding-left: 40px;
  padding-right: 24px;
  font-size: 10px;
  color: #717070;
  opacity: 0.5;
  margin-bottom: 18px;
}

.bot-avatar {
  position: absolute;
  top: -12px;
}

.user-avatar {
  position: absolute;
  top: 0;
  left: 24px;
  width: 40px;
  height: 40px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    &.admin-avatar {
      border-radius: 0;
    }
  }
}
.user-status.online {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  background: #5cb85c;
  border: 2px solid #ffffff;
  border-radius: 50%;
  z-index: 2;
}
.user-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #161616;
  white-space: nowrap;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.message-info {
  position: relative;
  padding-right: 70px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
}
.message-time {
  position: absolute;
  top: 0;
  right: 0;
  color: rgba(#717070, 0.5);
}
.user-role {
  margin-left: 3px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
  &--admin {
    color: #4d306e;
  }
  &--user {
    color: #5cb85c;
  }
  &--booster {
    color: #ff7149;
  }
}
.first-unread-message {
  position: relative;
  padding-top: 30px;
}
.new-messages-separator {
  position: relative;
  padding-bottom: 16px;
  padding-left: 24px;
  padding-right: 25px;
  text-align: center;
  &:before {
    position: absolute;
    content: "";
    top: 9px;
    left: 24px;
    right: 25px;
    height: 1px;
    background: #e2574c;
  }
  span {
    position: relative;
    display: inline-block;
    padding: 0 9px;
    font-size: 12px;
    line-height: 14px;
    color: #e2574c;
    background: #ffffff;
    z-index: 2;
  }
}
.delete-message {
  position: relative;
  margin-left: 4px;
  display: inline-block;
  width: 18px;
  height: 12px;
  background-color: #f1f2f4;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDEwIDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSIxIiBjeT0iMSIgcj0iMSIgZmlsbD0iIzcxNzA3MCIvPgogICAgPGNpcmNsZSBjeD0iNSIgY3k9IjEiIHI9IjEiIGZpbGw9IiM3MTcwNzAiLz4KICAgIDxjaXJjbGUgY3g9IjkiIGN5PSIxIiByPSIxIiBmaWxsPSIjNzE3MDcwIi8+Cjwvc3ZnPgo=");
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 2px;
  cursor: pointer;
  &:hover {
    span {
      opacity: 1;
      visibility: visible;
    }
  }
  span {
    position: absolute;
    left: 0;
    top: 100%;
    width: 160px;
    margin-top: 5px;
    display: block;
    padding: 13px;
    color: #717070;
    font-size: 14px;
    background: #ffffff;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    opacity: 0;
    visibility: hidden;
    transition: 0.3s;
    z-index: 10;
  }
}
.message-wrap--delete {
  .user-name {
    opacity: 0.7;
  }
  .user-avatar {
    img {
      -webkit-filter: grayscale(100%);
      filter: grayscale(100%);
      opacity: 0.7;
    }
  }
  .user-role--admin {
    color: #8b8b8b;
  }
  .user-role--user {
    color: #8b8b8b;
  }
  .user-role--booster {
    color: #8b8b8b;
  }
}
.message-content {
  word-wrap: break-word;
}
.message-content-delete {
  color: #717070;
  opacity: 0.5;
  font-style: italic;
}
</style>
